'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _ThemeHelper = require('helpers/theme/ThemeHelper');

var _ThemeHelper2 = _interopRequireDefault(_ThemeHelper);

var _helpers = require('helpers');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SocialRow: {
        displayName: 'SocialRow'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/SocialRow/SocialRow.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SocialRow = _wrapComponent('SocialRow')(function (_Component) {
    (0, _inherits3.default)(SocialRow, _Component);

    function SocialRow() {
        (0, _classCallCheck3.default)(this, SocialRow);
        return (0, _possibleConstructorReturn3.default)(this, (SocialRow.__proto__ || (0, _getPrototypeOf2.default)(SocialRow)).apply(this, arguments));
    }

    (0, _createClass3.default)(SocialRow, [{
        key: 'render',
        value: function render() {
            var View = _ThemeHelper2.default.getViewForComponent('SocialRow');
            var _props$product = this.props.product,
                name = _props$product.name,
                description = _props$product.description,
                pictures = _props$product.pictures,
                seoParams = _props$product.seoParams;

            description = (0, _utils.stripTags)(description);
            if (description.length > 250) {
                description = description.substr(0, 250) + '...';
            }
            var url = "";
            if (__CLIENT__) {
                url = global.location.host;
            } else {
                url = global.__HostName__;
            }
            var imgSrc = (0, _helpers.checkPicture)(pictures);

            return _react3.default.createElement(
                'div',
                { className: 'social-block' },
                _react3.default.createElement(_reactHelmet2.default, {
                    meta: [{ property: "og:url", content: url }, { property: "og:type", content: "article" }, { property: "og:title", content: name }, { property: "og:description", content: description }, { property: "og:image", content: imgSrc }, { property: "twitter:description", content: (0, _utils.stripTags)(description) }] }),
                _react3.default.createElement(View, this.props)
            );
        }
    }]);
    return SocialRow;
}(_react2.Component));

exports.default = SocialRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialRow/SocialRow.jsx
// module id = 1772
// module chunks = 0